(function () {
  if (window.SnowcubesSectionScripts) {
    if (typeof module !== "undefined" && module.exports) {
      module.exports = window.SnowcubesSectionScripts;
    }
    return;
  }

  const definitions = [
    { selector: "hero-section", key: "heroSection", dependency: "flickity" },
    { selector: "featured-collection", key: "featuredCollection", dependency: "flickity" },
    { selector: "shop-the-look", key: "shopTheLook", dependency: "flickity" },
    { selector: "quick-add-dropdown", key: "quickAddDropdown" },
  ];
  const requests = new Map();
  let started = false;

  function rootContains(root, selector) {
    if (!root) return false;
    if (typeof root.matches === "function" && root.matches(selector)) return true;
    return typeof root.querySelector === "function" && root.querySelector(selector) !== null;
  }

  function loadScript(key, url) {
    if (!url || typeof url !== "string") return null;
    if (requests.has(key)) return requests.get(key);

    const request = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = url;
      script.async = false;
      script.dataset.snowcubesSectionScript = key;
      script.addEventListener("load", () => resolve(script), { once: true });
      script.addEventListener(
        "error",
        () => {
          requests.delete(key);
          script.remove();
          reject(new Error(`Failed to load section script: ${key}`));
        },
        { once: true }
      );
      document.head.appendChild(script);
    });

    requests.set(key, request);
    return request;
  }

  function scan(root) {
    const urls = window.SnowcubesSectionAssetUrls || {};
    definitions.forEach(({ selector, key, dependency }) => {
      if (!customElements.get(selector) && rootContains(root || document, selector)) {
        if (!dependency) {
          const request = loadScript(key, urls[key]);
          if (request) request.catch(() => {});
          return;
        }

        const dependencyRequest = loadScript(dependency, urls[dependency]);
        if (!dependencyRequest) return;
        dependencyRequest
          .then(() => {
            if (customElements.get(selector)) return;
            const request = loadScript(key, urls[key]);
            if (request) return request;
          })
          .catch(() => {});
      }
    });
  }

  function onSectionLoad(event) {
    const eventRoot =
      event.target && event.target !== document
        ? event.target
        : document.getElementById(event.detail?.sectionId);
    scan(eventRoot || document);
  }

  function start() {
    if (started) return;
    started = true;
    document.addEventListener("shopify:section:load", onSectionLoad);
    scan(document);
  }

  function stop() {
    document.removeEventListener("shopify:section:load", onSectionLoad);
    started = false;
  }

  const api = { scan, loadScript, rootContains, requests, start, stop };
  window.SnowcubesSectionScripts = api;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }

  if (typeof module !== "undefined" && module.exports) {
    module.exports = api;
  }
})();
